import { BRAND_COLORS } from '@/config/appBrand'

export const CHART_COLORS = [
  BRAND_COLORS.primary,
  '#0EA5E9',
  '#475569',
  '#059669',
  '#DC2626',
  '#64748B',
  '#EA580C',
  '#0891B2',
]

export const CHART_THEME = {
  color: CHART_COLORS,
  textStyle: {
    fontFamily: "'IBM Plex Sans Thai', sans-serif",
    color: '#6B7280',
  },
  grid: {
    borderColor: '#D1D5DB',
  },
  categoryAxis: {
    axisLine: { lineStyle: { color: '#D1D5DB' } },
    axisLabel: { color: '#6B7280' },
    splitLine: { lineStyle: { color: '#E5E7EB' } },
  },
  valueAxis: {
    axisLine: { lineStyle: { color: '#D1D5DB' } },
    axisLabel: { color: '#6B7280', fontFamily: "'IBM Plex Mono', monospace" },
    splitLine: { lineStyle: { color: '#E5E7EB' } },
  },
}
